import React from "react";
import TextField from "@material-ui/core/TextField";
import {
  Typography,
  Button,
  Slider,
  Divider,
  Box,
  Switch,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  OutlinedInput,
  DialogActions,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import Container from "@material-ui/core/Container";
import { Link } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import QRCode from "qrcode.react";
import { BlockPicker, CirclePicker } from "react-color";
import { useTranslation } from "react-i18next";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import CustomAlert from "../../components/CustomAlert/CustomAlert";

import DraggableList from "../../components/draggableList";
import ListItemLink from "../../components/listItemLink";
import DialogWarning from "../../components/dialogWarning";
import TourHierarchyComponent from "../../components/TourHierarchy/TourHierarchyComponent";
import LoadingView from "../../components/loadingView";
import { ZoneMode } from "../../../constants/TourConstants";
import BreadcrumbTour from "../../components/breadcrumTour";
import SelectLocationDialog from "../../components/selectOnMapDialog";
import { ExpandMore, Map } from "@material-ui/icons";
import UnsavedChangesIndicator from "../../components/unsevedChangesIndicator";
import { Prompt } from "react-router-dom/cjs/react-router-dom.min";
import InfoPopover from "../../../utils/informationButton";
import NoSubscriptionBanner from "../home/components/noSubscriptionBanner";
import DisableToursPopover from "../../../utils/disableToursPopover";
import TutorialBubble from "../../../utils/tutorialBubble";
import SkeletonComponent from "../../components/Skeleton/SkeletonComponent";

const NewZoneView = (props) => {
  const { t } = useTranslation();
  function ValueLabelComponent(props) {
    const { children, open, value } = props;

    return (
      <Tooltip open={open} enterTouchDelay={0} placement="bottom" title={value}>
        {children}
      </Tooltip>
    );
  }

  return (
    <div className={props.classes.root}>
      <TourHierarchyComponent
        tourId={props.state.tourId}
        currentZoneId={props.state.zoneId !== -1 ? props.state.zoneId : null}
        role={props.state.role}
        tourDisabled={props.state.tourDisabled}
      />
      <div style={{ paddingBottom: 60 }} className={props.classes.mainContent}>
        <NoSubscriptionBanner
          role={props.state.role}
          redirectToSelectedPack={null}
          classes={props.classes}
        ></NoSubscriptionBanner>
        <DisableToursPopover
          userOpenedPopover={props.state.isDisableToursOpened}
        />
        <Prompt
          when={props.state.unsavedChanges}
          message={t("newZone.prompt_unsaved_changes")}
        />
        <Container className={props.classes.formContainer} maxWidth={false}>
          <UnsavedChangesIndicator show={props.state.unsavedChanges} />
          <BreadcrumbTour
            tourId={props.state.tourId}
            zoneId={props.state.zoneId}
            zoneMode={props.state.formDatas.zoneMode}
          />
          <br />
          <form
            className={props.classes.form}
            autoComplete="off"
            onSubmit={props.submitForm}
            style={{ position: "relative" }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                {props.state.showSkeletonZones ? (
                  <SkeletonComponent type="blocks"></SkeletonComponent>
                ) : (
                  <>
                    <Box className={props.classes.configContainer}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                        }}
                      >
                        <Box className={props.classes.textFieldContainerLight}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              width: "100%",
                            }}
                          >
                            <TextField
                              required
                              id="filled-required"
                              label={t("newZone.nom_de_la_zone")}
                              variant="outlined"
                              size="small"
                              defaultValue={props.state.formDatas.name}
                              onChange={props.updateName}
                              className={props.classes.textField}
                              multiline={true}
                              inputProps={{ maxLength: 1000 }}
                              key={
                                props.state.zoneLoaded
                                  ? "nameNotLoaded"
                                  : "nameLoaded"
                              }
                              style={{ flex: 1 }}
                            />
                            <InfoPopover
                              title={t("newZone.nom_de_la_zone")}
                              text={t("newZone.nom_de_la_zone_description")}
                            ></InfoPopover>
                          </div>
                          <Typography
                            style={{
                              fontSize: "12px",
                              color: "#94A3B8",
                              textAlign: "right",
                              marginTop: "4px",
                            }}
                          >
                            {(props.state.formDatas.name || "").length}/1000
                          </Typography>
                        </Box>

                        <Box className={props.classes.textFieldContainerLight}>
                          <FormControl className={props.classes.select}>
                            <InputLabel
                              variant="outlined"
                              id="select-response-type"
                            >
                              {t("newZone.type_de_zone")}
                            </InputLabel>
                            {props.state.gameMode == ZoneMode.MAP ? (
                              <Select
                                labelId="select-response-type"
                                id="select-response-type"
                                value={props.state.formDatas.zoneMode}
                                onChange={props.handleZoneModeChange}
                              >
                                <MenuItem value={ZoneMode.MAP}>
                                  {t("newZone.type_de_zone_options.map")}
                                </MenuItem>
                                <MenuItem value={ZoneMode.QRCODE}>
                                  {t("newZone.type_de_zone_options.qrcode")}
                                </MenuItem>
                              </Select>
                            ) : props.state.gameMode == ZoneMode.QRCODE ? (
                              <Select
                                labelId="select-response-type"
                                id="select-response-type"
                                value={props.state.formDatas.zoneMode}
                                onChange={props.handleZoneModeChange}
                              >
                                <MenuItem value={ZoneMode.QRCODE}>
                                  {t("newZone.type_de_zone_options.qrcode")}
                                </MenuItem>
                              </Select>
                            ) : (
                              <Select
                                labelId="select-response-type"
                                id="select-response-type"
                                value={props.state.formDatas.zoneMode}
                                onChange={props.handleZoneModeChange}
                              >
                                <MenuItem value={ZoneMode.AUTOMATIC_LAUNCH}>
                                  {t(
                                    "newZone.type_de_zone_options.automatic_launch"
                                  )}
                                </MenuItem>
                              </Select>
                            )}
                          </FormControl>
                        </Box>

                        <div
                          className={props.classes.twoColsRow}
                          style={{
                            display: "flex",
                            gap: "12px",
                            width: "100%",
                          }}
                        >
                          <Box
                            className={props.classes.textFieldContainer}
                            style={{ flex: 1 }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                                marginBottom: 10,
                              }}
                            >
                              <Typography
                                className={props.classes.switchFormControl}
                              >
                                {t("newZone.activer_la_zone")}
                              </Typography>
                              <InfoPopover
                                title={t("newZone.activer_la_zone")}
                                text={t("newZone.activer_la_zone_description")}
                                isWhite={false}
                              ></InfoPopover>
                            </div>

                            <Switch
                              checked={props.state.formDatas.isActive}
                              onChange={props.updateIsActive}
                            />
                          </Box>

                          <Box
                            className={props.classes.textFieldContainer}
                            style={{ flex: 1 }}
                          >
                            <Typography
                              className={props.classes.switchFormControl}
                            >
                              {t("newZone.durée_limite_zone")}
                            </Typography>

                            <TextField
                              required
                              id="timer"
                              label=""
                              variant="outlined"
                              size="small"
                              type="number"
                              defaultValue={props.state.formDatas.timer}
                              onChange={props.updateTimer}
                              className={props.classes.textField}
                              InputProps={{
                                inputProps: {
                                  max: 120,
                                  min: 0,
                                },
                              }}
                              key={
                                props.state.zoneLoaded
                                  ? "timerNotLoaded"
                                  : "timerLoaded"
                              }
                            />
                          </Box>
                        </div>

                        <Box
                          className={props.classes.textFieldContainerLight}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "10px 12px",
                          }}
                        >
                          <FormControlLabel
                            style={{ margin: 0, flex: 1 }}
                            control={
                              <Checkbox
                                name="enigmasInRandomOrder"
                                checked={
                                  props.state.formDatas.enigmasInRandomOrder
                                }
                                onChange={props.updateEnigmasInRandomOrder}
                                color="primary"
                              />
                            }
                            label={t(
                              "newZone.les_enigmes_se_lancent_ordre_aléatoire"
                            )}
                          />
                        </Box>

                        {props.state.formDatas.zoneMode == ZoneMode.MAP && (
                          <Box className={props.classes.textFieldContainer}>
                            <Typography
                              id="discrete-slider"
                              style={{
                                color: "black",
                                fontWeight: 700,
                                marginTop: 6,
                              }}
                              gutterBottom
                            >
                              {t("newZone.périmètre_de_la_zone")}
                            </Typography>
                            <Slider
                              getAriaValueText={props.valueSliderTourTimer}
                              aria-labelledby="discrete-slider"
                              step={5}
                              marks
                              min={5}
                              max={300}
                              valueLabelDisplay="on"
                              valueLabelFormat={(value) => `${value} mètres`}
                              value={props.state.formDatas.zoneRadius}
                              onChange={props.updateZoneRadius}
                              ValueLabelComponent={ValueLabelComponent}
                              variant="outlined"
                              size="small"
                              key={
                                props.state.zoneLoaded
                                  ? "zoneRadiusNotLoaded"
                                  : "zoneRadiusLoaded"
                              }
                            />
                            <div style={{ width: "100%", marginTop: 24 }}>
                              <Button
                                fullWidth
                                onClick={() => props.openMapDialog()}
                                className={props.classes.mapButton}
                                style={{
                                  backgroundColor: "#F8F9FA",
                                  borderRadius: "12px",
                                  border: "1px solid #E0E0E0",
                                  color: "#1F2937",
                                  padding: "12px 24px",
                                  marginBottom: 16,
                                  textTransform: "none",
                                  fontWeight: 500,
                                  transition: "all 0.2s ease-in-out",
                                  "&:hover": {
                                    backgroundColor: "#F1F5F9",
                                    borderColor: "#D1D5DB",
                                  },
                                }}
                              >
                                {t("newTour.select_pos")}
                              </Button>
                            </div>

                            <Box className={props.classes.coordsRow} style={{ display: "flex", gap: 12 }}>
                              <TextField
                                className={props.classes.textField}
                                label={t("newZone.longitude")}
                                variant="outlined"
                                size="small"
                                value={
                                  props.state.formDatas.coords.longitude != 0
                                    ? props.state.formDatas.coords.longitude
                                    : ""
                                }
                                onChange={props.updateCoordsLon}
                                inputProps={{
                                  className: props.classes.whiteTextfield,
                                  pattern: "-?(([1-9][0-9]*)|0)?(\\.[0-9]*)?",
                                }}
                                key={
                                  props.state.zoneLoaded
                                    ? "coordsLonNotLoaded"
                                    : "coordsLonLoaded"
                                }
                              />
                              <TextField
                                className={props.classes.textField}
                                id="filled-required"
                                label={t("newZone.latitude")}
                                variant="outlined"
                                size="small"
                                value={
                                  props.state.formDatas.coords.latitude != 0
                                    ? props.state.formDatas.coords.latitude
                                    : ""
                                }
                                onChange={props.updateCoordsLat}
                                inputProps={{
                                  className: props.classes.whiteTextfield,
                                  pattern: "-?(([1-9][0-9]*)|0)?(\\.[0-9]*)?",
                                }}
                                key={
                                  props.state.zoneLoaded
                                    ? "coordsLatNotLoaded"
                                    : "coordsLatLoaded"
                                }
                              />
                            </Box>
                          </Box>
                        )}

                        {props.state.formDatas.zoneMode == ZoneMode.QRCODE &&
                          props.state.zoneId !== -1 && (
                            <Box className={props.classes.textFieldContainer}>
                              <div
                                style={{
                                  position: "absolute",
                                  left: "-9999px",
                                  top: "-9999px",
                                  opacity: 0,
                                }}
                              >
                                {/* QR code invisible pour le téléchargement (400x400) */}
                                <QRCode
                                  id="zone_qr_code"
                                  includeMargin={true}
                                  size={600}
                                  value={props.state.formDatas.uuid}
                                  bgColor={props.state.qrCodeBgColor}
                                  fgColor={props.state.qrCodeFgColor}
                                />
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <QRCode
                                  includeMargin={true}
                                  size={190}
                                  value={props.state.formDatas.uuid}
                                  bgColor={props.state.qrCodeBgColor}
                                  fgColor={props.state.qrCodeFgColor}
                                />
                                <Button
                                  onClick={props.downloadQR}
                                  className={props.classes.qrButton}
                                >
                                  {t("newZone.qrcode_text.telecharger_qr_code")}
                                </Button>
                                <Box>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "start",
                                      alignItems: "start",
                                      width: "100%",
                                      marginBottom: 10,
                                    }}
                                  >
                                    <Button
                                      className={props.classes.linkQrCodeButton}
                                      onClick={props.openQrCodeDialog}
                                    >
                                      {t(
                                        "newZone.qrcode_text.importer_qr_code"
                                      )}
                                    </Button>
                                    <InfoPopover
                                      title={t(
                                        "newZone.qrcode_text.importer_qr_code"
                                      )}
                                      text={t(
                                        "newZone.qrcode_text.importer_qr_code_description"
                                      )}
                                    ></InfoPopover>
                                  </div>
                                  <Dialog
                                    disableEscapeKeyDown
                                    open={props.state.qrCodeDialogOpen}
                                    onClose={props.handleCloseCopyUuid}
                                    fullWidth
                                    maxWidth="sm"
                                  >
                                    <DialogTitle>
                                      {t("newZone.qrcode_text.choisir_la_zone")}
                                    </DialogTitle>
                                    <DialogContent>
                                      <Box
                                        component="form"
                                        sx={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                          width: "100%",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <FormControl
                                          sx={{ m: 1, width: "100%" }}
                                        >
                                          <InputLabel htmlFor="demo-dialog-native">
                                            {t("newZone.qrcode_text.parcours")}
                                          </InputLabel>
                                          <Select
                                            value={
                                              props.state.selectedTourQrCode
                                            }
                                            onChange={
                                              props.handleChangeTourQrCode
                                            }
                                            style={{
                                              width: "100%",
                                            }}
                                            input={
                                              <OutlinedInput
                                                label={t(
                                                  "newZone.qrcode_text.parcours"
                                                )}
                                                id="dialog-select-parcours"
                                                sx={{ width: "100%" }}
                                              />
                                            }
                                          >
                                            {props.state.toursUsers.map(
                                              (tour) => {
                                                if (
                                                  tour.id !== props.state.tourId
                                                ) {
                                                  return (
                                                    <option
                                                      key={tour.id}
                                                      value={tour.id}
                                                    >
                                                      {tour.title}
                                                    </option>
                                                  );
                                                }
                                              }
                                            )}
                                          </Select>
                                        </FormControl>
                                        <Box style={{ height: "10px" }}></Box>
                                        {props.state.selectedTourQrCode !==
                                          null ? (
                                          <>
                                            <FormControl
                                              sx={{
                                                m: 1,
                                                width: "100%",
                                              }}
                                            >
                                              <InputLabel id="demo-dialog-select-label">
                                                {t("newZone.qrcode_text.zone")}
                                              </InputLabel>
                                              <Select
                                                id="dialog-select-zone"
                                                value={
                                                  props.state
                                                    .selectedZoneQrCodeUuid
                                                }
                                                onChange={
                                                  props.handleChangeZoneQrCode
                                                }
                                                style={{
                                                  width: "100%",
                                                }}
                                                input={
                                                  <OutlinedInput
                                                    id="dialog-select-zone"
                                                    label="Zone"
                                                    sx={{ width: "100%" }}
                                                  />
                                                }
                                              >
                                                {props.state.zonesSelectedQrTour.map(
                                                  (zone) => {
                                                    if (
                                                      zone.zoneMode ==
                                                      ZoneMode.QRCODE
                                                    ) {
                                                      return (
                                                        <option
                                                          key={zone.id}
                                                          value={zone.uuid}
                                                        >
                                                          {zone.name}
                                                        </option>
                                                      );
                                                    }
                                                  }
                                                )}
                                              </Select>
                                            </FormControl>
                                            {props.state
                                              .selectedZoneQrCodeUuid ? (
                                              <>
                                                <Button
                                                  style={{ marginTop: "12px" }}
                                                  onClick={
                                                    props.handleResetZoneLinked
                                                  }
                                                >
                                                  {t(
                                                    "newZone.qrcode_text.reinitialiser_qr_code"
                                                  )}
                                                </Button>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </>
                                        ) : (
                                          <></>
                                        )}
                                      </Box>
                                    </DialogContent>
                                    <DialogActions>
                                      <Button
                                        color="primary"
                                        onClick={props.handleCloseCopyUuid}
                                      >
                                        {t(
                                          "newZone.dialog_warning.annuler_button"
                                        )}
                                      </Button>
                                      <Button
                                        color="#ffffff"
                                        backgroundColor="#841584"
                                        onClick={props.handleValidateCopyUuid}
                                      >
                                        {t("newZone.dialog_warning.valider")}
                                      </Button>
                                    </DialogActions>
                                  </Dialog>
                                </Box>
                                <div style={{ marginTop: 16, width: "100%" }}>
                                  <Typography style={{ marginBottom: 8 }}>
                                    {t(
                                      "newZone.qrcode_text.qr_code_background_color"
                                    )}
                                  </Typography>
                                  <CirclePicker
                                    color={props.state.qrCodeBgColor}
                                    colors={[
                                      "#FFFFFF",
                                      "#E3E8FA",
                                      "#E7FAEE",
                                      "#F9E4E4",
                                      "#E9FAFA",
                                    ]}
                                    onChangeComplete={
                                      props.handleQrCodeBackgroundColorChanged
                                    }
                                  />
                                </div>
                                <div style={{ marginTop: 16, width: "100%" }}>
                                  <Typography style={{ marginBottom: 8 }}>
                                    {t(
                                      "newZone.qrcode_text.qr_code_foreground_color"
                                    )}
                                  </Typography>
                                  <CirclePicker
                                    color={props.state.qrCodeFgColor}
                                    colors={[
                                      "#000000",
                                      "#031244",
                                      "#03461B",
                                      "#470303",
                                      "#023D3D",
                                    ]}
                                    onChangeComplete={
                                      props.handleQrCodeForegroundColorChanged
                                    }
                                  />
                                </div>
                              </div>
                            </Box>
                          )}
                      </div>
                    </Box>
                  </>
                )}
              </Grid>
            </Grid>

            <br></br>

            {props.state.showError ? (
              <CustomAlert
                severity="error"
                message={props.state.errorMessage}
                duration={5000}
                onClose={props.resetErrorAlert}
                height={90}
              />
            ) : null}
            {props.state.showSuccess ? (
              <CustomAlert
                severity="success"
                message={props.state.successMessage}
                duration={3000}
                onClose={props.resetSuccessAlert}
                height={90}
              />
            ) : null}
            <br />

            <DialogWarning
              open={props.state.dialogWaringOpened}
              primaryText={t("newZone.primaryTextDelete")}
              secondaryText={t("newZone.secondaryTextDelete")}
              primaryAction={props.deleteEnigma}
              closeAction={props.closeDeleteEnigmaDialog}
              idItem={props.state.enigmaIdToDelete}
              primaryButtonText={t("parcours_list.delete_button")}
              secondaryButtonText={t("parcours_list.cancel_button")}
            />
            <LoadingView
              className={props.classes.loadingView}
              open={props.state.loadingViewOpened}
            />

            <Box
              className={props.classes.actionBar}
              style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                padding: "16px",
                background:
                  "linear-gradient(to top, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.1) 65%, rgba(0, 0, 0, 0) 100%)",
                backdropFilter: "blur(12px)",
                WebkitMaskImage:
                  "linear-gradient(to top, black 0%, black 65%, transparent 100%)",
                maskImage:
                  "linear-gradient(to top, black 0%, black 65%, transparent 100%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                zIndex: 1000,
                boxShadow: "0 -1px 3px rgba(0, 0, 0, 0.05)",
              }}
            >
              <Link
                className={props.classes.returnButtonLink}
                to={`/parcours?id=${props.state.tourId}`}
                style={{ textDecoration: "none" }}
              >
                <Button
                  variant="outlined"
                  color="darkGrey"
                  style={{
                    minWidth: "120px",
                    height: "36px",
                    textTransform: "none",
                    borderRadius: "8px",
                    padding: "0 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#fff",
                  }}
                >
                  {t("newZone.retour_button")}
                </Button>
              </Link>
              <Button
                variant="contained"
                color="primary"
                className={`${props.classes.saveButton} ${props.state.role === "NO_SUBSCRIBTION" ||
                  props.state.tourDisabled
                  ? props.classes.buttonDisabled
                  : ""
                  }`}
                type="submit"
                style={{
                  minWidth: "120px",
                  height: "36px",
                  textTransform: "none",
                  borderRadius: "8px",
                  padding: "0 16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={props.submitForm}
              >
                {props.state.editing ? (
                  <div>{t("newZone.enregistrer_button")}</div>
                ) : (
                  <div>{t("newZone.ajouter_button")}</div>
                )}
              </Button>
            </Box>
          </form>
          {/* TUTO DÉSACTIVÉ - à réactiver si besoin
          {props.state.tutorialSteps?.step3 == false && (
            <TutorialBubble
              style={{ position: "absolute" }}
              message={t("tuto.step3")}
            ></TutorialBubble>
          )}
          {props.state.tutorialSteps?.step5 == false &&
            props.state.tutorialSteps?.step1 == true &&
            props.state.tutorialSteps?.step2 == true &&
            props.state.tutorialSteps?.step3 == true &&
            props.state.tutorialSteps?.step4 == true && (
              <TutorialBubble
                style={{ position: "absolute" }}
                message={`${t("tuto.step5Part1")}${props.state.testCode ? props.state.testCode : ""
                  }${t("tuto.step5Part2")}`}
              ></TutorialBubble>
            )}
          */}
          <SelectLocationDialog
            currentZoneId={props.state.zoneId}
            zones={props.state.zones}
            lat={props.showLatOnMap}
            lng={props.showLngOnMap}
            zoneRadius={props.state.formDatas.zoneRadius}
            initLocationLat={props.tourLocationLat}
            initLocationLng={props.tourLocationLng}
            coordsNE={props.state.cameraBoundsNE}
            coordsSW={props.state.cameraBoundsSW}
            open={props.mapDialogOpen}
            onClose={() => props.closeMapDialog()}
            onLocationSelected={(location) => {
              props.setLocation(location);
            }}
          />{" "}
        </Container>
      </div>
    </div>
  );
};

export default NewZoneView;
